<template>
  <div class="invoice">
    <div v-if="isShowTitle" class="title">电子普通发票</div>
    <div class="tips">
      提示：修改或完善开票信息，请前往 发票管理->发票助手
    </div>
    <div class="content">
      <div class="invoice-form">
        <el-form
          ref="form"
          :model="form"
          :rules="rules"
          label-suffix="："
          label-width="120px"
          size="small"
        >
          <el-form-item label="单位名称" prop="companyName">
            <span>{{ form.companyName || '-' }}</span>
          </el-form-item>
          <el-form-item label="纳税人识别号" prop="companyTaxNo">
            <span>{{ form.companyTaxNo || '-' }}</span>
          </el-form-item>
          <el-form-item label="单位地址" prop="companyAddress">
            <span v-if="readOnly">{{ form.companyAddress || '-' }}</span>
            <el-input
              v-else
              v-model.trim="form.companyAddress"
              maxlength="50"
              show-word-limit
              placeholder="请输入单位地址"
            />
          </el-form-item>
          <el-form-item label="单位电话" prop="companyMobile">
            <span v-if="readOnly">{{ form.companyMobile || '-' }}</span>
            <el-input
              v-else
              v-model.trim="form.companyMobile"
              placeholder="请输入单位电话"
              maxlength="20"
              show-word-limit
            />
          </el-form-item>
          <el-form-item label="开户银行" prop="companyBankName">
            <span v-if="readOnly">{{ form.companyBankName || '-' }}</span>
            <el-input
              v-else
              v-model.trim="form.companyBankName"
              placeholder="请输入开户银行"
              maxlength="100"
              show-word-limit
            />
          </el-form-item>
          <el-form-item label="银行账号" prop="companyBankAccount">
            <span v-if="readOnly">{{
              form.companyBankAccount | bankFilter
            }}</span>
            <el-input
              v-else
              v-model.trim="form.companyBankAccount"
              placeholder="请输入银行账号"
              maxlength="30"
              show-word-limit
            />
          </el-form-item>
          <el-form-item label="收票人手机号" prop="employeeMobile">
            <span v-if="readOnly">{{ form.employeeMobile || '-' }}</span>
            <el-input
              v-else
              v-model.trim="form.employeeMobile"
              placeholder="请输入收票人手机号"
              maxlength="20"
              show-word-limit
            />
          </el-form-item>
          <el-form-item label="收票人邮箱" prop="employeeEmail">
            <span v-if="readOnly">{{ form.employeeEmail || '-' }}</span>
            <el-input
              v-else
              v-model.trim="form.employeeEmail"
              placeholder="请输入收票人邮箱"
              maxlength="50"
              show-word-limit
            />
          </el-form-item>
        </el-form>
        <div class="invoice-form-operate">
          <el-button
            v-if="readOnly"
            size="small"
            @click="editInvoiceInfo"
          >修改</el-button>
          <template v-else>
            <el-button
              v-if="invoiceInfo.id"
              size="small"
              @click="cancel"
            >取消</el-button>
            <el-button
              type="primary"
              size="small"
              @click="saveInvoiceInfo"
            >保存</el-button>
          </template>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// 字典
import { invoiceTypeDict, isCompanyDict } from '@/dictionary/financial'
// 工具
import { formValid, strUtil } from 'jczh-ui'
// 接口
import {
  addInvoiceApi,
  changeInvoiceApi,
  getInvoiceApi
} from '@/api/financial/invoice'

/**
 * @description 电子普通发票组件
 */
export default {
  name: 'GeneralInvoice',

  filters: {
    bankFilter(bankCard) {
      return bankCard ? strUtil.bankCardDivision(bankCard) : '-'
    }
  },

  props: {
    companyId: {
      type: [String, Number],
      required: true
    },

    // 发票地址id
    invoiceAddressId: {
      type: [String, Number],
      default: ''
    },

    // 当前用户是否为企业员工
    isEmployee: {
      type: Boolean,
      default: false
    },

    // 是否显示标题
    isShowTitle: {
      type: Boolean,
      default: true
    }
  },

  data() {
    return {
      readOnly: true,
      form: {
        id: undefined,
        invoiceType: invoiceTypeDict.GENERAL_ELECTRONIC_INVOICE.value,
        companyId: undefined,
        companyName: undefined,
        companyTaxNo: undefined,
        companyAddress: undefined,
        companyMobile: undefined,
        companyBankName: undefined,
        companyBankAccount: undefined,
        employeeMobile: undefined,
        employeeEmail: undefined,
        isCompany: isCompanyDict.COMPANY.value
      },
      rules: {
        companyName: {
          required: true,
          message: '请输入单位名称',
          trigger: 'blur'
        },
        companyTaxNo: {
          required: true,
          message: '请输入纳税人识别号',
          pattern: /^[a-zA-Z\d]*$/g,
          trigger: 'blur'
        },
        employeeMobile: [
          {
            required: true,
            message: '请输入收票人手机号码',
            trigger: 'blur'
          },
          formValid.mobileRegular
        ],
        employeeEmail: [
          {
            required: true,
            message: '请输入收票人邮箱地址',
            trigger: 'blur'
          },
          formValid.emailRegular
        ]
      },
      invoiceInfo: {
        // 单位名称,
        companyName: undefined,
        // 纳税人识别号
        companyTaxNo: undefined,
        // 发票id
        id: undefined,
        // 单位地址
        companyAddress: undefined,
        // 单位电话
        companyMobile: undefined,
        // 开户银行
        companyBankName: undefined,
        // 开户银行账号
        companyBankAccount: undefined,
        // 收票人手机
        employeeMobile: undefined,
        // 收票人邮箱
        employeeEmail: undefined
      }
    }
  },

  computed: {
    editInvoiceInfoApi() {
      return this.invoiceInfo.id ? changeInvoiceApi : addInvoiceApi
    }
  },

  watch: {
    companyId: {
      handler(val) {
        if (val) {
          this.getInvoiceInfo()
        }
      },
      immediate: true
    },

    invoiceAddressId: {
      handler(val) {
        if (val) {
          this.getInvoiceInfo()
        }
      },
      immediate: true
    }
  },

  methods: {
    // 获取发票信息
    getInvoiceInfo() {
      getInvoiceApi({
        type: invoiceTypeDict.GENERAL_ELECTRONIC_INVOICE.value,
        companyId: this.companyId,
        invoiceAddressId: this.invoiceAddressId,
        isCompany: this.isEmployee
          ? isCompanyDict.COMPANY.value
          : isCompanyDict.PERSONAL.value
      })
        .then(res => {
          const keys = Object.keys(this.invoiceInfo)
          keys.forEach(key => {
            this.invoiceInfo[key] = res.data[key]
          })

          const formKeys = Object.keys(this.form)
          formKeys.forEach(key => {
            this.form[key] = res.data[key]
          })
          this.form.invoiceType =
            invoiceTypeDict.GENERAL_ELECTRONIC_INVOICE.value
          this.readOnly = Boolean(res.data?.id)
          this.$emit('getInvoiceInfo', this.invoiceInfo)
        })
        .catch(err => {
          this.$message.error(err?.data?.message || '获取电子普通发票信息失败')
        })
    },

    // 编辑发票信息
    editInvoiceInfo() {
      this.readOnly = false
    },

    // 取消编辑
    cancel() {
      const formKeys = Object.keys(this.form)
      formKeys.forEach(key => {
        this.form[key] = this.invoiceInfo[key]
      })
      this.form.invoiceType = invoiceTypeDict.GENERAL_ELECTRONIC_INVOICE.value
      this.readOnly = true
    },

    // 保存发票信息
    async saveInvoiceInfo() {
      try {
        if (!(await this.validInvoiceForm())) return
        await this.$confirm('是否保存电子发票信息', '系统提示', {
          type: 'warning'
        })
        if (this.companyId) {
          this.form.companyId = this.companyId
        }
        if (this.invoiceAddressId) {
          this.form.invoiceAddressId = this.invoiceAddressId
        }

        // 如果当前用户为企业员工，则isCompany为1，否则为0
        this.form.isCompany = this.isEmployee
          ? isCompanyDict.COMPANY.value
          : isCompanyDict.PERSONAL.value

        const res = await this.editInvoiceInfoApi(this.form)
        this.readOnly = true
        this.$message.success(res?.data?.message || '保存成功')
        await this.getInvoiceInfo()
      } catch (err) {
        if (err?.data) {
          this.$message.error(err?.data?.message || '保存失败')
        }
      }
    },

    // 表单校验
    async validInvoiceForm() {
      try {
        await this.$refs.form.validate()
        return true
      } catch (err) {
        this.$message.error('表单填写有误，请按照提示要求填写')
        return false
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.invoice {
  display: flex;
  flex-direction: column;
  align-items: center;
  .title {
    font-size: 20px;
    color: $text-color;
  }
  .content {
    .invoice-form {
      ::v-deep .el-form {
        width: 400px;
        .el-form-item {
          margin-bottom: 20px;
        }

        &.detail-form {
          .el-form-item {
            margin-bottom: 0;
          }
        }
      }

      .invoice-form-operate {
        text-align: center;
      }
    }
  }
}
// .tips {
//   color: $third-text-color;
//   font-size: 12px;
//   margin: -10px 0 10px 0
// }
</style>
